export default __webpack_public_path__ + "static/media/withlogo.002.dfba28d0.jpeg";